import { Sparkles, Check, TrendingUp } from "lucide-react";

const CANDIDATES = [
    { initials: "A.K", role: "Senior ML Engineer", score: 96, tags: ["LLM Apps", "RAG", "MLOps"], top: true },
    { initials: "R.S", role: "Senior ML Engineer", score: 91, tags: ["PyTorch", "Serving"] },
    { initials: "M.D", role: "ML Platform Engineer", score: 88, tags: ["K8s", "Eval"] },
    { initials: "J.P", role: "Applied Scientist", score: 84, tags: ["NLP", "Vector DB"] },
];

/**
 * Reusable "TalentIQX" candidate-ranking mockup.
 * Presentational only — used inside hero/simulator/section visuals.
 */
export default function CandidateRankingPanel({ className = "" }) {
    return (
        <div
            className={`rounded-2xl bg-white border border-[#303030]/10 shadow-[0_30px_70px_-40px_rgba(0,0,0,0.55)] overflow-hidden ${className}`}
            data-testid="mockup-candidate-ranking"
            aria-hidden="true"
        >
            <div className="flex items-center justify-between px-4 py-3 border-b border-[#303030]/8 bg-[#FAFAF8]">
                <div className="flex items-center gap-2">
                    <span className="w-6 h-6 grid place-items-center rounded-md bg-[#FF4040]/12 text-[#FF4040]">
                        <Sparkles className="w-3.5 h-3.5" />
                    </span>
                    <span className="text-[12px] font-semibold text-[#303030]">TalentIQX · Ranking</span>
                </div>
                <span className="font-mono text-[10px] text-[#303030]/55">1,204 scored</span>
            </div>

            <ul className="divide-y divide-[#303030]/6">
                {CANDIDATES.map((c, i) => (
                    <li
                        key={c.initials}
                        className={`flex items-center gap-3 px-4 py-2.5 ${c.top ? "bg-[#FF4040]/[0.035]" : ""}`}
                    >
                        <span className="font-mono text-[11px] text-[#303030]/45 w-4">{i + 1}</span>
                        <span className="w-8 h-8 grid place-items-center rounded-lg bg-[#303030] text-white text-[11px] font-semibold shrink-0">
                            {c.initials}
                        </span>
                        <div className="flex-1 min-w-0">
                            <p className="text-[12.5px] font-semibold text-[#303030] leading-tight">{c.role}</p>
                            <div className="mt-1 flex items-center gap-2">
                                <div className="h-1.5 flex-1 rounded-full bg-[#303030]/8 overflow-hidden">
                                    <div
                                        className="h-full rounded-full bg-[#FF4040] pqx-scorebar"
                                        style={{ width: `${c.score}%`, animationDelay: `${i * 90}ms` }}
                                    />
                                </div>
                                <span className="font-mono text-[11px] font-semibold text-[#FF4040] w-7 text-right">{c.score}</span>
                            </div>
                        </div>
                        {c.top && (
                            <span className="hidden sm:inline-flex items-center gap-1 text-[10px] font-semibold text-[#FF4040] bg-[#FF4040]/10 rounded-full px-2 py-0.5">
                                <Check className="w-3 h-3" /> shortlist
                            </span>
                        )}
                    </li>
                ))}
            </ul>

            <div className="px-4 py-2.5 border-t border-[#303030]/8 flex items-center justify-between bg-[#FAFAF8]">
                <span className="text-[11px] text-[#303030]/60 inline-flex items-center gap-1.5">
                    <TrendingUp className="w-3.5 h-3.5 text-[#FF4040]" /> Explainable match reasoning
                </span>
                <span className="font-mono text-[10px] text-[#303030]/45">recruiter-verified</span>
            </div>
        </div>
    );
}
